<template>
    <v-container fluid>
    <v-dialog v-model="showMessage" transition="dialog-bottom-transition" max-width="600">
        <v-card>
            <v-toolbar
              color="primary"
              dark
            >
            <span>Mensagem</span>
            <v-spacer></v-spacer>
                 <v-btn color="white" text @click="showMessage = false;"> Fechar </v-btn>
            </v-toolbar>
          <v-card-actions>
            <v-spacer></v-spacer>
       
          </v-card-actions>
          <v-card-text>
            <span>{{message}}</span>
          </v-card-text>
        </v-card>
    </v-dialog>
    
      <modal-contact :showDialog = "showDialog" @close = "showDialog =false" @selContact = "selContact"></modal-contact>
     <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Novo 
        <v-progress-circular
          v-if="!loaded"
          indeterminate
          color="secondary"
        ></v-progress-circular>
      </div>
      <v-spacer></v-spacer>
  
    </v-row>
    <!-- <v-card class="mx-auto" max-width="500"> -->
   
    <v-container style="max-width: 100%">
      <!-- Stack the columns on mobile by making one full-width and the other half-width -->
      <v-row style="width: 100%">
        <v-col cols="14" md="4">
          <v-card :loading="loading" max-width="600">
            <template slot="progress">
              <v-progress-linear
                color="primary"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-card-title>Dados </v-card-title>
            
            <br />
            <v-card-text v-show="!loading">
              <v-row align="center" class="mx-0"> </v-row>
              <div>
                <v-list v-if="deal" dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <v-text-field label ="Título" v-model = "deal.title">
                        </v-text-field>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
              <!-- @click:append-outer="searchContact"  -->
                <!-- :append-outer-icon=" 'mdi-magnify ' " -->
                      <v-row>
                        <v-col cols="7">
                          <v-text-field label ="Nome do contato" v-model = "deal.contactName"
                                        
                                        :disabled="true"   
                                       clear-icon="mdi-close-circle"
                                       clearable
                                      

                                            @click:clear="clearContact"
                          > 
                          </v-text-field>
                        </v-col>
                        <v-col cols="1" v-if ="deal.contactId">
                               <v-icon  @click="clearContact" class="mt-4">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="1" >
                      <v-icon @click="searchContact" class=" mt-4">mdi-account-search</v-icon>
                        </v-col>
                      </v-row>
                        </v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
<!-- 
                  <v-list-item>
                    <v-list-item-content v-if="deal.Owner">
                      <v-list-item-title>Responsável</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ deal.Owner.Name }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item> -->
                </v-list>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn  class="primary" @click="saveDeal" :disabled = "saving" > <span v-if="!saving">Salvar</span>

                    <v-progress-circular
          v-if="saving"
          indeterminate
          color="secondary"
        ></v-progress-circular>

              </v-btn>
            </v-card-actions>
            <v-divider class="mx-4"></v-divider>
          </v-card>
        </v-col>

        <v-col cols="12" md="8">
          <v-card color="basil">
            <!-- <v-card-title class="text-center justify-center py-6">
              <h1 class="font-weight-bold display-3 basil--text">Documentos</h1>
            </v-card-title> -->

            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="basil"
              grow
            >
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" >
              <v-tab-item >

                <v-row class="ma-2" >
                  <v-spacer></v-spacer>
                  <v-btn class="primary" @click="newProject" >+Novo</v-btn>
                </v-row>
                <div 
                 
                  class="ma-4"
                  v-for="project in deal.projects"
                  :key="project.Id"
                  cols="12"
                >
                  <v-card
                    class="mx-auto"
                    style="border-radius: 15px; border-style: solid; margin: 0px"
                    outlined
                  >
                    <v-list-item three-line>
                                <v-btn
                    class="secondary ma-4"
                    style="max-width: 100%"
                    @click="deleteProject(project.id, index)"
                  >
                    <v-icon>mdi-delete</v-icon></v-btn > 
                      <v-list-item-content>
                        <v-list-item-title class="display-1">
                     
                        </v-list-item-title>
                        <v-list-item-title class="display-1">
                    <span style="font-size: 10px"> {{ project.Id }}</span>
                        </v-list-item-title>
                        <v-list-item-title class="display-1">
                          <span style="font-size: 10px">
                            <!-- {{ project.TemplateId }} -->
                            </span  >
                        </v-list-item-title>

                        <v-list-item-subtitle> Potência: <span v-decimal-format="project.solarPlant.dcPower"></span>  kWp </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          Preço: <span v-money-format="project.quote.price"></span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                           Data: <span v-date-format="project.createdAt"></span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-btn
                        outlined
                        rounded
                        text
                        class="primary"
                        dark
                        @click="openproject(project.id)"
                      >
                        Abrir
                      </v-btn>
                    </v-list-item>
                  </v-card>
                </div>
              </v-tab-item>

           
        
             
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <!-- Columns start at 50% wide on mobile and bump up to 33.3% wide on desktop -->

      <!-- Columns are always 50% wide, on mobile and desktop -->
    </v-container>
    </v-container>
</template>

<script>
import Deal from '../../../../libraries/classes/Deal';
import hebelApi from '../../../../libraries/hebel/hebelApi';
import ModalContact from '../../components/modals/ModalContact';

export default {
  name: "Deal",
  props: ["dealId"],
  components:{
    ModalContact
  },

  computed:{
     labelSingular:function(){
      return  window.style? window.style.deals.label.singular:'Negócio' 
    },
      labelPlural:function(){
      return window.style? window.style.deals.label.plural:'Negócios'
    }
  },
  data() {
    return {
      loaded:true,
      loading: false,
      tab: null,
      items: ["Projetos"],
      showDialog:false,
      showMessage:false,
      deals: [],
      orders: [],
      deal: {},
      cards: [{}],
      saving:false,
      message:"",
      user:{},
    };
  },
  async mounted() {
    
    this.user = this.$session.get('user');


    if (!this.dealId) {
        this.deal = new Deal();
        this.deal.owner = this.user;
        this.deal.ownerId = this.user.uid;

    }else{
      this.deal = await hebelApi.deals.getFromId(this.dealId);
      if(this.deal.contactId){
          this.deal.contact = await hebelApi.contacts.getFromId(this.deal.contactId);
      }
      if(!this.deal.owner){
        this.deal.owner = this.user;
        this.deal.ownerId = this.user.uid;
      } 
        
      this.deal.projects = await hebelApi.projects.getFromDealId(this.deal.id);
      this.$forceUpdate();

    }
  },
  methods: {
    selContact(contact){
      //alert(JSON.stringify(contact));
      this.deal.contactId = contact.id;
      this.deal.contactName = contact.name;

      this.showDialog = false;
    },
    async saveDeal(){

      if(!this.deal.contactId){ 
        this.message = "Selecionar contato ou criar um novo"
        this.showMessage = true;
        return;
      } 

      this.saving = true;
      var x = await hebelApi.deals.upsert(this.deal);
      this.deal.id = x.id;
      //this.dealId = this.deal.id;
      this.saving = false;
     // this.$router.push(this.deal.id)

    },
    deleteProject(projectId, index) {
      //this.$dao.deleteProject(window.eid,projectId )
      hebelApi.projects.delete(projectId);
      this.deal.projects.splice(index, 1);
    },

    newProject() {

      if(!this.deal.id){
        this.message = `Salvar ${this.labelSingular} para criar projetos`
        this.showMessage = true;
        return;
      } 
       if(!this.deal.contactId){ 
        this.message = "Selecionar contato ou criar um novo"
        this.showMessage = true;
        return;
      } 
      this.$session.set("deal", this.deal    );
      this.$router.push(`/deal/${this.deal.id }/newproject`);
  
    },
    clearContact(){
      this.deal.contactName = "";
      this.deal.contactId = null;
    //  alert("clear contact")
    },
      searchContact(){
          this.showDialog =true;
         // alert("search contact")
      },
    goToDeals() {
      this.$router.push("/deals");
    },

    openOrder(orderId) {
      this.$router.push("/order/" + orderId);
    },
    openproject(projectId) {
      this.$router.push("/project/" + projectId);
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
    test() {
      alert("test");
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
.labelValue {
  display: block;
  width: 120px;
  margin: auto;
  text-align: center;
}
.cardLabel {
  position: absolute;
  right: 10px;
  top: 20px;
  height: 60px;
  width: 240px;
  background-color: #4c6563;
  border-radius: 15px;
}
table {
  border: none !important;
}
.v-list-item-content {
}
</style>
